<!--経費一覧画面-->
<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;">
      <!--テーブル-->
      <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <!--検索model-->
        <div class="search-module-k0006 ">
          <el-row style="padding-top:5px;padding-left:5px" :gutter="20">
            <el-col :span="7">
              <div>
                <el-date-picker v-model="kikanVal1" size="mini" type="date" style="width: 130px;font-size:12px;" :editable="false" :clearable="false" format="yyyy/MM/dd"></el-date-picker>
              </div>
            </el-col>
            <el-col :span="2" style="padding-left: 2px; padding-right: 10px;">
              <div>
                &nbsp;
              </div>
            </el-col>
            <el-col :span="7">
              <div>
                <el-date-picker v-model="kikanVal2" size="mini" type="date" style="width: 130px;font-size:12px;" :editable="false" :clearable="false" format="yyyy/MM/dd"></el-date-picker>
              </div>
            </el-col>
            <el-col :span="2">
              <div>
                &nbsp;
              </div>
            </el-col>
            <!--检索按钮-->
            <el-col :span="5">
              <div>
                <el-button type="primary" class="css-button_k0006 css-btn_k0006" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click="query_btn">{{$t('COMMON.LBL_SEARCH')}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table style=" border: 0px solid #AAAAAA" :header-cell-style="k0006HeaderStyle" :cell-style="k0006IsCellStyle" :header-row-class-name="k0006HeaderClass" :cell-class-name="k0006IsCellClass" :data="list" border @row-click="k0006RowOnClick" size="mini">
          <!--隐藏列-->
          <!--作業日-->
          <el-table-column fixed="left" prop="jobDate" align="center" v-if="false"></el-table-column>
          <!--ステータス-->
          <el-table-column fixed="left" prop="jobStateCd" align="center" v-if="false"></el-table-column>
          <el-table-column fixed="left" prop="jobStateName" align="center" v-if="false"></el-table-column>
          <!--企業名-->
          <el-table-column fixed="left" prop="companyName" align="center" v-if="false"></el-table-column>
          <!--店舗名-->
          <el-table-column fixed="left" prop="storeName" align="center" v-if="false"></el-table-column>
          <!--職種-->
          <el-table-column fixed="left" prop="typeName" align="center" v-if="false"></el-table-column>
          <!--入店予定-->
          <el-table-column fixed="left" prop="esStoreIn" align="center" v-if="false"></el-table-column>
          <!--入店実績-->
          <el-table-column fixed="left" prop="acStoreIn" align="center" v-if="false"></el-table-column>
          <!--退店予定-->
          <el-table-column fixed="left" prop="esStoreOut" align="center" v-if="false"></el-table-column>
          <!--退店実績-->
          <el-table-column fixed="left" prop="acStoreOut" align="center" v-if="false"></el-table-column>
          <!--更新時間-->
          <el-table-column fixed="left" prop="updateDate" align="center" v-if="false"></el-table-column>
          <!--勤怠承認-->
          <el-table-column fixed="left" prop="approvalFlag" align="center" v-if="false"></el-table-column>
          <!--連携フラグ-->
          <el-table-column fixed="left" prop="transmitFlag" align="center" v-if="false"></el-table-column>
          <!--显示列-->
          <!--作業日\ステータス\出勤区分-->
          <el-table-column fixed="left" prop="col1" :label="$t('MODULE.K0006_LBL_col1')" width="" text-align="center" align="left">
            <template slot-scope="scope">
                {{scope.row.jobDate}}
                <!-- 作業区分は「1」集中補充、「2」新店改装・CRの場合	ステータスは作業状態を表示する -->
                <div><el-image style="vertical-align: middle" v-if="scope.row.workType!=3 && scope.row.jobStateCd==0" :src="imgIconPlan" alt />
                <el-image style="vertical-align: middle" v-if="scope.row.workType!=3 && scope.row.jobStateCd==1" :src="imgIconUnderway" alt />
                <el-image style="vertical-align: middle" v-if="scope.row.workType!=3 && scope.row.jobStateCd==2"  :src="imgIconComplete" alt />
                <!--作業区分は「3」-0:計画、1:出発済、2:入店済、3:退店済、4:作業完了-->
                <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==0"  :src="imgIconPlan" alt></el-image>
                <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==1"  :src="imgIconGoComplete" alt></el-image>
                <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==2"  :src="imgIconUnderway" alt></el-image>
                <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==3"  :src="imgIconCloseComplete" alt></el-image>
                <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==4"  :src="imgIconComplete" alt></el-image>
                <template style="vertical-align: middle" v-if="scope.row.workType==1||scope.row.workType==2"><span style="vertical-align: middle">{{scope.row.jobStateName}}</span></template>
                <template style="vertical-align: middle" v-if="scope.row.workType==3"><span style="vertical-align: middle">{{scope.row.personalJobValue}}</span></template></div>
                <div>{{scope.row.attenAbbr}}</div>
            </template>
          </el-table-column>
          <!--企業名\現場名\サービス名-->
          <el-table-column fixed="left" prop="col2" :label="$t('MODULE.K0006_LBL_col2')" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.companyName}}<br />
              {{scope.row.fieldName}}<br />
              {{scope.row.serviceName}}
            </template>
          </el-table-column>
          <!--入店予定\入店実績-->
          <el-table-column fixed="left" prop="col3" :label="$t('MODULE.K0006_LBL_col3')" width="" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.esStoreIn}}{{$t('MODULE.K0006_LBL_YO')}}</div>
              <div>{{scope.row.acStoreIn}}{{$t('MODULE.K0006_LBL_JI')}}</div>
            </template>
          </el-table-column>
          <!--退店予定\退店実績-->
          <el-table-column fixed="left" prop="col4" :label="$t('MODULE.K0006_LBL_col4')" width="" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.esStoreOut}}{{$t('MODULE.K0006_LBL_YO')}}</div>
              <div>{{scope.row.acStoreOut}}{{$t('MODULE.K0006_LBL_JI')}}</div>
              <div style='display:none'>{{scope.row.crewCd}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as amsApi from "../api/k_0006"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      imgIconComplete: require("@/statics/images/Complete.png"),
      imgIconPlan: require("@/statics/images/plan.png"),
      imgIconUnderway: require("@/statics/images/underway.png"),
      imgIconCloseComplete: require("@/statics/images/close_complete.png"),
      imgIconGoComplete: require("@/statics/images/go_complete.png"),
      list: [],
      queryParams: {
        siteId: '' //サイトid
      },
      kikanVal1: '',
      kikanVal2: '',
      fullscreenLoading: false,
    };
  },
  methods: {
    // 初期化
    init_query() {
      // 期間初期化
      var search_condition = JSON.parse(localStorage.getItem('search_condition'))
      if (search_condition == null) {
        var today = new Date()
        var torrom = new Date()
        this.kikanVal1 = today
        var torrom = torrom.setDate(torrom.getDate() + 1)
        torrom = new Date(torrom)
        this.kikanVal2 = torrom
        var search_condition = {}
        search_condition.fromDate = this.dateToString(this.kikanVal1, '0')
        search_condition.toDate = this.dateToString(this.kikanVal2, '0')
        localStorage.setItem("search_condition", JSON.stringify(search_condition))
      } else {
        var fromDate = search_condition.fromDate
        var toDate = search_condition.toDate
        if (search_condition.fromDate != null) {
          this.kikanVal1 = new Date(fromDate.substring(0, 4) + '/' + fromDate.substring(4, 6) + '/' + fromDate.substring(6, 8))
        } else {
          this.kikanVal1 = null
        }
        if (search_condition.toDate != null) {
          this.kikanVal2 = new Date(toDate.substring(0, 4) + '/' + toDate.substring(4, 6) + '/' + toDate.substring(6, 8))
        } else {
          this.kikanVal2 = null
        }
      }
      amsApi.home().then(res => {
        this.userInfo = res.items.userInfo
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo))
      })
    },
    // 検索ボタン
    query_btn() {
      var search_condition = {}
      search_condition.fromDate = this.dateToString(this.kikanVal1, '0')
      search_condition.toDate = this.dateToString(this.kikanVal2, '0')
      localStorage.setItem("search_condition", JSON.stringify(search_condition))
      this.query()
    },
    // 検索
    query() {
      var dateFrom = ''
      var dateTo = ''
      if (this.dateToString(this.kikanVal1, '0') !== null) {
        dateFrom = this.dateToString(this.kikanVal1, '0')
      } else {
        dateFrom = null
      }
      if (this.dateToString(this.kikanVal2, '0') !== null) {
        dateTo = this.dateToString(this.kikanVal2, '0')
      } else {
        dateTo = null
      }
      if (dateFrom != null && dateTo != null && dateFrom > dateTo) {
        this.$message.error({ message: this.$t('COMMON.MSG_MESSAGE_ERROR_FROMDATE'), showClose: true })// 期間開始日＜＝期間終了日で設定してください。
      } else {
        var Params = {
          "dateFrom": dateFrom,
          "dateTo": dateTo
        }
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        })
        setTimeout(() => {
          loading.close()
        }, 2000)
        // 検索処理
        amsApi.k_0006(Params).then(res => {
          // 戻るリスト
          this.total = res.total;
          if (res.code === 300) {
            this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          }
          this.list = res.items
          loading.close()
        })
      }
    },
    // TABLEHeader样式
    k0006HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; '
    },
    // TABLE单元格样式
    k0006IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;fontSize:10pt'
    },
    // 单击行事件
    k0006RowOnClick(thisRowDate, column, cell, event) {
      //计划的场合，点击无效
      if ((thisRowDate.workType != 3 && thisRowDate.jobStateCd == 0) || (thisRowDate.workType == 3 && thisRowDate.personalJobState == 0)) {
        return
      }
      if (column.property !== 'col1' && column.property !== 'col2') {
        return
      }

      localStorage.setItem('obj', JSON.stringify(thisRowDate))
      localStorage.setItem(url.routerUrl_K0007, JSON.stringify(true))
      this.$router.push({ path: url.routerUrl_K0007 })
    },
    k0006HeaderClass({ row, rowIndex }) {
      return 'k0006HeaderClass'
    },
    k0006IsCellClass({ row, rowIndex }) {
      return 'k0006IsCellClass'
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      var vm = this
      vm.$router.push({ path: url.routerUrl_Menu })
    },
    // date->string(yyyy/mm/dd  yyyymmdd) 変化
    dateToString(dateTime, changeType) {
      var strTime = ''
      if (dateTime == null) { return null }
      var year = dateTime.getFullYear()
      var month = (dateTime.getMonth() + 1).toString()
      var day = (dateTime.getDate()).toString()
      if (month.length === 1) { month = '0' + month }
      if (day.length === 1) { day = '0' + day }
      if (changeType === '0') {
        strTime = year + month + day
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day
      } else {
        strTime = year + month + day
      }
      return strTime
    },
    // date->string(HH:MM) 変化
    dateToStringHHMM(dateTime, addHour) {
      var strTime = ''
      if (dateTime == null) { return '' }
      var hours = dateTime.getHours() + addHour
      var minutes = dateTime.getMinutes()
      if (hours < 10) { hours = '0' + hours }
      if (minutes < 10) { minutes = '0' + minutes }
      strTime = hours + ':' + minutes
      return strTime
    },
    // 時刻(分) str->num (00:00->num)
    stringToMin(time) {
      if (time === null || time === '') {
        return 0
      } else {
        return Number(time.substring(0, 2)) * 60 + Number(time.substring(3, 5))
      }
    }
  },
  created() {
    // 初期化
    this.init_query()
    // 期間より検索
    this.query()
  },
}

</script>
<style scope>
/*导航logo*/
.img-icon {
  outline: 0 none !important;
}

/*カラー*/
.css-white {
  color: #ffffff;
}
.k0006IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.k0006HeaderClass .cell {
  white-space: pre-line;
}
.search-module-k0006 {
  padding-bottom: 10px;
  margin-bottom: 5px; /*检索模块与表格间距*/
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
  border: solid 0px #999999;
}
/*ボタン*/
.css-button_k0006 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 10pt;
}
/*按钮经过样式*/
.css-btn_k0006:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_k0006:active,
.css-btn_k0006:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
  color: #ffffff;
}
/*导航*/
.home-content-menu_k0006 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}
/*面包屑*/
.el-crumb_k0006 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
</style>





// WEBPACK FOOTER //
// src/module/page/k_0006.vue